import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface DepartmentTab {
  id: string;
  label: string;
}

interface FactItem {
  title: string;
  value: string;
}

interface OutcomeItem {
  title: string;
  description: string;
}

interface LabItem {
  title: string;
  image: string;
  description: string;
  equipment?: string;
}

interface ProgrammeItem {
  sno: number;
  name: string;
  duration: string;
}
interface ClubEventItem {
  sno: number;
  clubName: string;
  eventName: string;
  resourcePersons: string[];
  date: string;
}
interface ActivityPhotoItem {
  image: string;
  alt: string;
}
interface MouItem {
  sno: number;
  industryName: string;
  signedDate: string;
  scope: string;
  outcomes: string[];
}
interface PlacementStudentItem {
  sno: number;
  studentName: string;
  designation: string;
  companyName: string;
}

interface PlacementYearGroup {
  academicYear: string;
  records: PlacementStudentItem[];
}
interface ValueAddedCourseItem {
  sno: number;
  courseName: string;
  duration: string;
  companyName: string;
}
interface NptelRecordItem {
  staffName: string;
  subject: string;
  grade: string;
}
interface AchievementItem {
  sno: number;
  studentNames: string[];
  eventName: string;
  collegeName: string;
  level: string;
  eventDate: string;
  awardName: string;
}
interface ConferenceItem {
  sno: number;
  conferenceName: string;
  paperTitle: string;
  authors: string[];
  collegeName: string;
  date: string;
}

interface PatentItem {
  sno: number;
  academicYear: string;
  name: string;
  category: string;
  inventionTitle: string;
  applicationNumber: string;
  publicationDate: string;
  status: string;
}
  interface AlumniItem {
  image: string;
  alt: string;
  batch: string;
  name: string;
  designation: string;
  organization: string;
  location?: string;
}

@Component({
  selector: 'app-downloads-page',
  templateUrl: './downloads-page.component.html',
  styleUrls: ['./downloads-page.component.scss']
})
export class DownloadsPageComponent implements OnInit {
  isToggled = false;
  selectedTab = 'tab1';

  departmentName = 'Department of Civil Engineering';
  establishedYear = '2009';
  programmeSummary = '1 UG Programme, 1 PG Programme';
  contactEmail = 'hodcivil@fmcet.ac.in';

  admissionNotice =
    'Admissions open for 2026 : B.E. (Civil), B.E. (CSE), B.E. (CSE - AI & ML), B.E. (CSE - CS),B.Tech. (AI & DS), B.E. (ECE), B.E. (EEE), B.E. (Mechanical), MBA,M.E. (CSE), M.E. (Embedded System Technologies),M.E. (Thermal Engineering), M.E. (Environmental Engineering)';
      
  tabs: DepartmentTab[] = [
    { id: 'tab1', label: 'About the Department' },
    { id: 'tab2', label: 'Vision & Mission' },
    { id: 'tab3', label: "PEO's" },
    { id: 'tab4', label: 'POs & PSOs' },
    { id: 'tab14', label: 'Programme Offered' },
    { id: 'tab5', label: 'Laboratory Facilities' },
    { id: 'tab6', label: 'Association & Club Activities' },
    { id: 'tab7', label: "MoU's" },
    { id: 'tab8', label: 'Placement Record' },
    { id: 'tab9', label: 'Industrial Visit' },
    { id: 'tab10', label: 'Value Added Courses' },
    { id: 'tab11', label: 'Alumni' },
    { id: 'tab12', label: 'Achievements' },
    { id: 'tab13', label: 'NPTEL' },
    { id: 'tab15', label: 'Research' }
  ];

  aboutParagraphs: string[] = [
    'The Department of Civil Engineering was started in the academic year 2009. The programme is offered under the affiliation of Anna University, Chennai.',
    'We offer bachelor’s programmes and value-added learning opportunities from the curriculum to prepare industry-ready professionals. The department has well-equipped laboratory facilities and a team of highly qualified faculty members experienced in diversified fields of Civil Engineering.',
    'Exclusive models are set up in the laboratories to help students understand fundamentals and advanced technology. Students are encouraged to actively participate in co-curricular and extracurricular activities.',
    'The department conducts various placement-oriented activities such as aptitude training, technical skill development, and refresher courses relevant to industrial needs, in addition to training programmes organized by the Training & Placement Cell.',
    'The Class of 2014, which was our second batch of students, secured 38th University Rank. Our graduates have been placed in companies like Shoba Developers, L&T, URC Constructions, and in government sectors. Some graduates were also placed in reputed Gulf companies with packages up to 8.50 Lakhs per annum.'
  ];

  quickFacts: FactItem[] = [
    { title: 'Affiliation', value: 'Anna University, Chennai' },
    { title: 'Academic Focus', value: 'Industry-ready civil engineering education with laboratory and skill development support' },
    { title: 'Student Development', value: 'Co-curricular, extracurricular, placement, aptitude, and technical skill activities' },
    { title: 'Career Outcomes', value: 'Placements in construction companies, government sectors, and overseas opportunities' }
  ];

  visionText =
    'To stimulate and cast Civil Engineering expectant as expert and dynamic infrastructure developers.';

  missionPoints: string[] = [
    'To harmonize high quality civil engineering education and research.',
    'To inspire students’ logical reasoning, creativity, and communication abilities.',
    'To cultivate understanding of emerging trends through personal exploration and partnership with industries and government organizations.',
    'To inculcate innovation and eco-sustainable construction in the minds of budding civil engineers to face ever evolving challenges.'
  ];

  peos: string[] = [
    'Gain knowledge and skills in Civil Engineering which will enable them to have a career and professional accomplishment in public or private sector organizations.',
    'Become consultants on complex real-life Civil Engineering problems related to infrastructure development, especially housing, construction, water supply, sewerage, transport, and spatial planning.',
    'Become entrepreneurs and develop processes and technologies to meet desired infrastructure needs of society and formulate solutions that are technically sound, economically feasible, and socially acceptable.',
    'Perform investigations for solving Civil Engineering problems by conducting research using modern equipment and software tools.',
    'Function in multi-disciplinary teams and advocate policies, systems, processes, and equipment to support Civil Engineering.'
  ];

  programOutcomes: OutcomeItem[] = [
    {
      title: 'Engineering Knowledge',
      description:
        'Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.'
    },
    {
      title: 'Problem Analysis',
      description:
        'Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using first principles of mathematics, natural sciences, and engineering sciences.'
    },
    {
      title: 'Design / Development of Solutions',
      description:
        'Design solutions for complex engineering problems and design system components or processes that meet specified needs with appropriate consideration for public health, safety, cultural, societal, and environmental considerations.'
    },
    {
      title: 'Conduct Investigations of Complex Problems',
      description:
        'Use research-based knowledge and research methods including design of experiments, analysis and interpretation of data, and synthesis of the information to provide valid conclusions.'
    },
    {
      title: 'Modern Tool Usage',
      description:
        'Create, select, and apply appropriate techniques, resources, and modern engineering and IT tools including prediction and modeling to complex engineering activities with an understanding of their limitations.'
    },
    {
      title: 'The Engineer and Society',
      description:
        'Apply reasoning informed by contextual knowledge to assess societal, health, safety, legal, and cultural issues and the consequent responsibilities relevant to professional engineering practice.'
    },
    {
      title: 'Environment and Sustainability',
      description:
        'Understand the impact of professional engineering solutions in societal and environmental contexts, and demonstrate knowledge of and need for sustainable development.'
    },
    {
      title: 'Ethics',
      description:
        'Apply ethical principles and commit to professional ethics, responsibilities, and norms of engineering practice.'
    },
    {
      title: 'Individual and Teamwork',
      description:
        'Function effectively as an individual, and as a member or leader in diverse teams and multidisciplinary settings.'
    },
    {
      title: 'Communication',
      description:
        'Communicate effectively on complex engineering activities with the engineering community and society at large through reports, design documentation, presentations, and clear instructions.'
    },
    {
      title: 'Project Management and Finance',
      description:
        'Demonstrate knowledge and understanding of engineering and management principles and apply these to individual work and team-based project management in multidisciplinary environments.'
    },
    {
      title: 'Life-long Learning',
      description:
        'Recognize the need for, and have the preparation and ability to engage in independent and life-long learning in the broadest context of technological change.'
    }
  ];

  programSpecificOutcomes: OutcomeItem[] = [
    {
      title: 'Knowledge of Civil Engineering Discipline',
      description:
        'Demonstrate in-depth knowledge of Civil Engineering discipline with an ability to evaluate, analyze, and synthesize existing and new knowledge.'
    },
    {
      title: 'Critical Analysis and Innovation',
      description:
        'Critically analyze complex Civil Engineering problems, apply independent judgment for synthesizing information, and make innovative advances in theoretical, practical, and policy contexts.'
    },
    {
      title: 'Conceptualization and Evaluation of Engineering Solutions',
      description:
        'Conceptualize and solve Civil Engineering problems, evaluate potential solutions, and arrive at technically feasible, economically viable, and environmentally sound solutions with due consideration for health, safety, and socio-cultural factors.'
    }
  ];

  labs: LabItem[] = [
    {
      title: 'Concrete & Highway Engineering Lab',
      image: 'assets/img/conhigh.jpg',
      description:
        'Provides hands-on experience with various civil structures, materials, and testing methods used in concrete and highway engineering.'
    },
    {
      title: 'Geotechnical Engineering Lab',
      image: 'assets/img/soil.jpg',
      description:
        'Focuses on soil testing, rock mechanics, and geotechnical analysis for civil engineering applications.',
      equipment: ''
    },
    {
      title: 'Strength of Material Lab',
      image: 'assets/img/som.jpg',
      description:
        'Supports understanding of material behavior, strength analysis, and performance under various loading conditions.',
      equipment: ''
    },
    {
      title: 'Environmental Engineering Lab',
      image: 'assets/img/envengg.jpg',
      description:
        'Studies air, water, and soil pollution control methods with practical exposure to environmental testing.',
      equipment: 'Water Quality Testing Kits, Air Pollution Sensors'
    }
  ];

  programmes: ProgrammeItem[] = [
    {
      sno: 1,
      name: 'B.E. Civil Engineering',
      duration: '4 Years'
    },
        {
      sno: 2,
      name: 'M.E. Environmental Engineering',
      duration: '2 Years'
    },

  ];
    clubAcademicYear = '2025 - 2026';

  clubNames: string[] = ['Green Club', 'Smeaton Club'];

  clubEvents: ClubEventItem[] = [
    {
      sno: 1,
      clubName: 'Smeaton Club',
      eventName: 'Online Student Seminar',
      resourcePersons: ['Gowthamman A D'],
      date: '24.01.2026'
    },
    {
      sno: 2,
      clubName: 'Green Club',
      eventName: 'Online Student Seminar',
      resourcePersons: ['Praveenraj K'],
      date: '14.02.2026'
    },
    {
      sno: 3,
      clubName: 'Green Club',
      eventName: 'World Water Day',
      resourcePersons: [
        'Dr. S. Ramalingam, Prof. / S&H',
        'Dr. S. Muthupoongodi, ASP / S&H'
      ],
      date: '23.03.2026'
    }
  ];
clubActivityHighlight =
  'Poster Presentation Competition Conducted to Celebrate “World Water Day” on 23.03.2026.';

clubActivityPhotos: ActivityPhotoItem[] = [
  {
    image: 'assets/img/civil/aa1.jpeg',
    alt: 'Poster Presentation Competition - World Water Day - Photo 1'
  },
  {
    image: 'assets/img/civil/aa2.jpeg',
    alt: 'Poster Presentation Competition - World Water Day - Photo 2'
  }
];
 mouDetails: MouItem[] = [
  {
    sno: 1,
    industryName: 'DS Associates',
    signedDate: '24.03.2026',
    scope: 'Placement, Industrial visit and Internship',
    outcomes: [
      'Student Projects (IV year)',
      'Guest Lectures and Seminars'
    ]
  },
  {
    sno: 2,
    industryName: 'CAD n CODE',
    signedDate: '08.10.2025',
    scope: 'Placement, Industrial visit and Internship',
    outcomes: [
      'Guest Lectures and Seminars',
      'Conducted Student Workshop on STAAD PRO'
    ]
  }
];

mouPhotoNote =
  'MoU activities and industry collaboration records of the Department of Civil Engineering .';

mouPhotos: ActivityPhotoItem[] = [
  {
    image: 'assets/img/civil/mou1.jpeg',
    alt: 'MoU Signing - Department of Civil Engineering - Photo 1'
  },
  {
    image: 'assets/img/civil/mou2.jpeg',
    alt: 'MoU Signing - Department of Civil Engineering - Photo 2'
  }
];
placementRecords: PlacementYearGroup[] = [
  {
    academicYear: '2025-2026',
    records: [
      {
        sno: 1,
        studentName: 'Nantha S',
        designation: 'Assistant Surveyor',
        companyName: 'Cemintia metro, Chennai'
      },
      {
        sno: 2,
        studentName: 'Sridharan N',
        designation: 'Site Engineer',
        companyName: 'Cloudline Construction, Chennai'
      },
      {
        sno: 3,
        studentName: 'Prakash J',
        designation: 'Site Engineer',
        companyName: 'Cloudline Construction, Chennai'
      },
      {
        sno: 4,
        studentName: 'Sivabalan',
        designation: 'Site Engineer',
        companyName: 'Madurai Materitech Lab, Madurai'
      }
    ]
  },
  {
    academicYear: '2024-2025',
    records: [
      {
        sno: 1,
        studentName: 'Ajay Kumar M',
        designation: 'Site Engineer',
        companyName: 'Narbavi Properties and Developers, Coimbatore'
      },
      {
        sno: 2,
        studentName: 'Boobalan A',
        designation: 'Site Engineer',
        companyName: 'Vigos Construction, Madurai'
      },
      {
        sno: 3,
        studentName: 'Jai Rishi Boobesh S',
        designation: 'Site Engineer',
        companyName: 'Narbavi Properties and Developers, Coimbatore'
      },
      {
        sno: 4,
        studentName: 'Kaleeshwaran P',
        designation: 'Site Engineer',
        companyName: 'Narbavi Properties and Developers, Coimbatore'
      },
      {
        sno: 5,
        studentName: 'Ramana S',
        designation: 'Site Engineer',
        companyName: 'Narbavi Properties and Developers, Coimbatore'
      },
      {
        sno: 6,
        studentName: 'Sakthivel B',
        designation: 'Software Trainer',
        companyName: 'CADD Centre, Sivagangai'
      },
      {
        sno: 7,
        studentName: 'Selvabharathi T',
        designation: 'Assistant Surveyor',
        companyName: 'RK Construction, Coimbatore'
      },
      {
        sno: 8,
        studentName: 'Thayanithi M',
        designation: 'Site Engineer',
        companyName: 'Vigos Construction, Madurai'
      },
      {
        sno: 9,
        studentName: 'Yuvaraja K',
        designation: 'Software Engineer',
        companyName: 'Qspider company Chennai'
      },
      {
        sno: 10,
        studentName: 'Thirukkumaran V',
        designation: 'Site Engineer',
        companyName: 'NCR company Chennai'
      }
    ]
  }
];
valueAddedCourses: ValueAddedCourseItem[] = [
  {
    sno: 1,
    courseName: 'Advanced 3D Modeling for Civil Engineers using Sketch up',
    duration: '19.01.2026 to 23.01.2026',
    companyName: 'Tamil CAD Info'
  },
  {
    sno: 2,
    courseName: 'Building Information Modeling',
    duration: '26.02.2025 to 04.03.2025',
    companyName: 'Tamil CAD Info'
  }
];
nptelRecords: NptelRecordItem[] = [
  {
    staffName: 'J. Thavaseelan',
    subject: 'OBE and Accreditation',
    grade: 'Silver - Elite'
  },
  {
    staffName: 'J. Thavaseelan',
    subject: 'Plastic Waste Management',
    grade: 'Silver - Elite'
  },
  {
    staffName: 'G. Alagumurugan',
    subject: 'OBE and Accreditation',
    grade: 'Silver - Elite'
  },
  {
    staffName: 'P. Jeya Kumar',
    subject: 'Plastic Waste Management',
    grade: 'Elite'
  },
  {
    staffName: 'A. Bharath Kumar',
    subject: 'Principles of Construction Management',
    grade: 'Elite'
  },
  {
    staffName: 'A. Bharath Kumar',
    subject: 'Concrete Technology',
    grade: 'Silver - Elite'
  },
  {
    staffName: 'A. Bharath Kumar',
    subject: 'OBE and Accreditation',
    grade: 'Silver - Elite'
  },
  {
    staffName: 'S. Karthikeyan',
    subject: 'OBE and Accreditation',
    grade: 'Elite'
  }
];
achievements: AchievementItem[] = [
  {
    sno: 1,
    studentNames: ['A.D. Gowthaman'],
    eventName: 'Best Editor',
    collegeName: 'Radio City Programme at FMCET',
    level: '-',
    eventDate: '25.03.2026',
    awardName: 'First Prize'
  },
  {
    sno: 2,
    studentNames: [
      'A.D. Gowthaman',
      'K. Praveenraj',
      'D.K. Rajarajan',
      'A. Dharanidharan',
      'D. Jeyanath'
    ],
    eventName: 'Short Film',
    collegeName: 'Mangayarkarasi College of Engineering, Madurai',
    level: 'State',
    eventDate: '06.03.2026',
    awardName: 'Second Prize'
  },
  {
    sno: 3,
    studentNames: ['M. Ganikasri'],
    eventName: 'Dance',
    collegeName: 'Mangayarkarasi College of Engineering, Madurai',
    level: 'State',
    eventDate: '06.03.2026',
    awardName: 'Second Prize'
  },
  {
    sno: 4,
    studentNames: ['A.D. Gowthaman', 'D.K. Rajarajan'],
    eventName: 'Rise & Fall',
    collegeName: 'Solaimalai College of Engineering & Technology',
    level: 'State',
    eventDate: '07.02.2026',
    awardName: 'First Prize'
  },
  {
    sno: 5,
    studentNames: ['M. Ganikasri', 'P. Subasri'],
    eventName: 'Surv -X',
    collegeName: 'Solaimalai College of Engineering & Technology',
    level: 'State',
    eventDate: '07.02.2026',
    awardName: 'Second Prize'
  },
  {
    sno: 6,
    studentNames: [
      'N. Nantha',
      'S. Srimathi',
      'J. Prakash',
      'N. Sridharan',
      'S. Yogeshwari'
    ],
    eventName: 'Short Film',
    collegeName: 'NPR College of Engineering & Technology',
    level: 'State',
    eventDate: '21.02.2025',
    awardName: 'First Prize'
  },
  {
    sno: 7,
    studentNames: ['N. Nantha'],
    eventName: 'Photography',
    collegeName: 'NPR College of Engineering & Technology',
    level: 'State',
    eventDate: '21.02.2025',
    awardName: 'Third Prize'
  },
  {
    sno: 8,
    studentNames: ['N. Sridharan'],
    eventName: 'Art Capture',
    collegeName: 'Sethu Institute of Technology, Kariyapatti',
    level: 'State',
    eventDate: '06.03.2025',
    awardName: 'First Prize'
  },
  {
    sno: 9,
    studentNames: ['J. Mohammed Thoufiq'],
    eventName: 'Paper Presentation',
    collegeName: 'PSNA, Dindigul',
    level: 'State',
    eventDate: '25.10.2024',
    awardName: 'First Prize'
  }
];

achievementPhotos: ActivityPhotoItem[] = [
  {
    image: 'assets/img/civil/achi1.jpeg',
    alt: 'Surv-X Achievement Photo'
  },
  {
    image: 'assets/img/civil/achi2.jpeg',
    alt: 'Short Film Achievement Photo'
  }
];

achievementPhotoNotes: string[] = [
  'M.Ganikasri and P.Subasri won second prize in Surv-X at Viyugam’26 organized by Solaimalai College of Engineering on 07.02.2026.',
  'A.D.Gowthaman, K.Praveenraj, D.K.Rajarajan, A.Dharanidharan, D.Jeyanath won second prize in Short Film at Milan’26 organized by Mangayarkarasi College of Engineering on 06.03.2026.'
];
conferenceRecords: ConferenceItem[] = [
  {
    sno: 1,
    conferenceName: 'National Conference on Advanced Civil Engineering',
    paperTitle: 'Study of Delay Management in Construction Industry and Rectification by ERP',
    authors: ['J. Thavaseelan', 'A. Bharthkumar', 'S. Karthikeyan'],
    collegeName: 'Motihari College of Engineering, Bihar',
    date: '13.03.2026 to 14.03.2026'
  },
  {
    sno: 2,
    conferenceName: 'National Conference on Advanced Civil Engineering',
    paperTitle: 'Experimental Analysis on Concrete as Partial Replacement using Egg Shell and Cal-Sil Powder',
    authors: ['A. Bharthkumar', 'P. Stella Jansi Rani'],
    collegeName: 'Motihari College of Engineering, Bihar',
    date: '13.03.2026 to 14.03.2026'
  },
  {
    sno: 3,
    conferenceName: 'International Conference on Recent Advances and Innovations in Science, Engineering, Technology & Management',
    paperTitle: 'Stabilization of Black Cotton Soil Using Rice Husk Ash and Quarry Fines ISBN: 978-93-6163-778-0',
    authors: ['J. Thavaseelan'],
    collegeName: 'Solamalai College of Engineering, Madurai',
    date: '25.04.2025'
  },
  {
    sno: 4,
    conferenceName: 'International Conference on Engineering Horizons: Innovation, Advancements and Sustainability',
    paperTitle: 'Utilization of GFRP, Steel Slag and Rubber Tire Waste as Replacements for Fine Aggregate in Concrete with Varying Mixing Ratios ISBN: 978-81-984820-7-5',
    authors: ['J. Thavaseelan', 'S. Karthikeyan'],
    collegeName: 'SRM College, Madurai',
    date: '16.05.2025'
  },
  {
    sno: 5,
    conferenceName: 'International Conference on Engineering Horizons: Innovation, Advancements and Sustainability',
    paperTitle: 'Integration of Artificial Neural Network and GIS for Urban Master Planning in Tamilnadu ISBN: 978-81-984820-7-5',
    authors: ['Alagu Murugan G'],
    collegeName: 'SRM College, Madurai',
    date: '16.05.2025'
  }
];

patentRecords: PatentItem[] = [
  {
    sno: 1,
    academicYear: '2024-2025',
    name: 'Mr. G. Alagu Murugan',
    category: 'Design',
    inventionTitle: 'Handy Concrete Thermal Conductivity Meter',
    applicationNumber: '451978-001',
    publicationDate: '25/06/2025',
    status: 'Granted'
  },
  {
    sno: 2,
    academicYear: '2024-2025',
    name: 'Mr. J. Thavaseelan',
    category: 'Design',
    inventionTitle: 'Risk Assessment Method using Multivariate Optimization Mathematics',
    applicationNumber: '202511128359',
    publicationDate: '26/12/2025',
    status: 'Granted'
  }
];
industrialVisitPhotos: ActivityPhotoItem[] = [
  {
    image: 'assets/img/civil/iv1.jpeg',
    alt: 'Industrial Visit to RL Construction Madurai'
  },
  {
    image: 'assets/img/civil/iv2.jpeg',
    alt: 'Industrial Visit to Star Fly Ash Bricks Sivaganga'
  },
  {
    image: 'assets/img/civil/iv3.jpeg',
    alt: 'Industrial Visit to Golden Bricks Sivaganga'
  },
  {
    image: 'assets/img/civil/iv4.jpeg',
    alt: 'Industrial Visit to Bridge Construction at Koripalayam Madurai'
  }
];

industrialVisitNotes: string[] = [
  'Industrial Visit to RL Construction, Madurai on 21.08.2025.',
  'Industrial Visit to Star Fly Ash Bricks, Sivaganga on 19.03.2025.',
  'Industrial Visit to Golden Bricks to gain the knowledge about manufacturing of bricks, Sivaganga on 19.03.2025.',
  'Industrial Visit to Bridge Construction at Koripalayam to gain the knowledge about pile foundation and steel design, Madurai on 12.09.2025.'
];
alumniRecords: AlumniItem[] = [
  {
    image: 'assets/img/civil/a1.jpeg',
    alt: 'Alumni - B. Dharma Muneeswaran',
    batch: '2012-2016',
    name: 'B. Dharma Muneeswaran',
    designation: 'Civil Engineer',
    organization: 'Desert Precision Contracting LLC',
    location: 'Dubai'
  },
  {
    image: 'assets/img/civil/a2.jpeg',
    alt: 'Alumni - Er. L. Alagu Surya Lakshmi',
    batch: '2010-2014',
    name: 'Er. L. Alagu Surya Lakshmi',
    designation: 'Quantity Surveyor',
    organization: 'Adura Business Corporation'
  },
  {
    image: 'assets/img/civil/a4.jpeg',
    alt: 'Alumni - Er. S. Vignesh Veeran',
    batch: '2017-2021',
    name: 'Er. S. Vignesh Veeran',
    designation: 'Assistant Engineer',
    organization: 'Rural Development & Panchayat Raj Department',
    location: 'Tamil Nadu Government'
  },
  {
    image: 'assets/img/civil/a3.jpeg',
    alt: 'Alumni - Er. G. Alagu',
    batch: '2010-2014',
    name: 'Er. G. Alagu',
    designation: 'Assistant Engineer',
    organization: 'Public Works Department',
    location: 'Tamil Nadu Government'
  }
];

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'Department Profile';
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  ngOnInit(): void {}
}